module.exports = {
    extends: [
        '/',
        'base',
        'form',
        'form'
    ],

    config: {
        loadWhenPrimaryKeyPresentOnly: true,
        resourceRegisterKey: 'productProperties',
        isFullyVertical: true,
    },

    model: {
        // preventSubmit: true,
    },

    hooks: {
        _attach(){
            const data = this.resourceData.data || {}
            const primaryKey = (data.attributes || {})[data.primaryKey || 'id']
            if(!primaryKey && !this.config.preventModelFieldsBeingRendered){
                this.config.preventModelFieldsBeingRendered = true
                this.refresh(false)
            }
        }
    },

    handlers: [
        {
            name: 'onSubmitDone',
            componentClass: 'templates_mblx_products_propertiesForm',
            handle: function(callerComponent, nodeData, insertPerformed){
                const changedData = (nodeData || {}).data || {}
                const changedPrimaryKey = (changedData.attributes || {})[changedData.primaryKey || 'id']
                const thisData = this.resourceData.data || {}
                const thisPrimaryKey = (thisData.attributes || {})[thisData.primaryKey || 'id']

                if(callerComponent.componentIndex !== this.componentIndex && changedPrimaryKey === thisPrimaryKey && !this.config.preventModelFieldsBeingRendered) {
                    this.refresh()
                }
            }
        }
    ]
}
